import { Button } from "@swot/base-components";

export function SwotMissingEntity(props: { readonly title?: string | undefined; readonly message?: string | undefined; readonly onBack?: (() => void) | undefined; readonly onRefresh?: (() => void) | undefined }) {
  return (
    <section className="swot-missing-entity" role="status">
      <h2>{props.title ?? "Record not found"}</h2>
      <p>{props.message ?? "The requested record could not be found."}</p>
      <div className="swot-missing-entity__actions">
        {props.onRefresh ? <Button label="Refresh" variant="secondary" onClick={props.onRefresh} /> : null}
        {props.onBack ? <Button label="Back to list" variant="secondary" onClick={props.onBack} /> : null}
      </div>
    </section>
  );
}
